import { init as initSignUp } from '~/javascripts/sessions/init_sign_up';

document.addEventListener('DOMContentLoaded', () => {
  initSignUp();
});
